import './error.css';
const ErrorPageAdmin = () => {
    return (
        <div className="container  min-width w-75 mb-5   d-flex justify-content-center">
            <div className="">
                <h1 className="text-danger" id="access-text"><code className='text-danger'> 🚫 403 Access Denied </code></h1>
                <hr className="w3-border-white w3-animate-left" />
                <h3 className="w3-center w3-animate-right" id="access-text">
                    You do not have ADMIN privileges .</h3>

            </div>
        </div>
    )
}

export default ErrorPageAdmin;